<template>
  <v-radio-group
      v-model="textValue"
      row
      :label="label + ':'"
  >
    <v-radio
        label="Yes"
        :value="1"
        @click="setValue(1)"
    ></v-radio>
    <v-radio
        label="No"
        :value="0"
        @click="setValue(0)"
    ></v-radio>
  </v-radio-group>
</template>
<script>
export default {
  name: 'NoBill',
  props: {
    value: {
      type: [Number],
    },
    label: {
      type: String,
    },
    field: {
      type: Object,
      required: true,
    },
  },

  computed: {
    textValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    setValue(value) {
      if (this.textValue === value) {
        this.textValue = null;
      } else {
        this.textValue = value;
      }
    },
  },
};
</script>
